// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_dc3c4c39","icon":"_8467d061","questionWrapper":"_42e56d77","questionWrapperExpanded":"_5d769690","question":"_f25dc964","answer":"_196353f6"};